<div class="container-fluid">
  <form [formGroup]="form1">
    <div class="row wrap">

      <!-- Column 1  -->
      <div class="col-md-6">
        <mat-form-field class="flex-1">
          <mat-label>Refund reason & description of issue</mat-label>
          <textarea matInput formControlName="description" readonly="{{formReadOnly}}" matTextareaAutosize
          matAutosizeMinRows=10 matAutosizeMaxRows=500></textarea>
          @for (validation of validationMessages.description; track validation) {
            <mat-error>
              @if (form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)) {
                <mat-error class="error-message"
                  >
                  {{validation.message}}
                </mat-error>
              }
            </mat-error>
          }
          <mat-hint>Please provide all details for refund.</mat-hint>
        </mat-form-field>


      </div>

      <!-- Column 2  -->
      <div class="col-md-6">
        <mat-form-field>
          <mat-label>Amount Requested by Guest</mat-label>
          <input matInput formControlName="double_1" readonly="{{formReadOnly}}"><span
        matPrefix>$&nbsp;&nbsp;&nbsp;</span>
        @for (validation of validationMessages.description; track validation) {
          <mat-error>
            @if (form1.get('double_1').hasError(validation.type) && (form1.get('double_1').dirty || form1.get('double_1').touched)) {
              <mat-error class="error-message"
                >
                {{validation.message}}
              </mat-error>
            }
          </mat-error>
        }
        <mat-hint>May be $0 if no request</mat-hint>
      </mat-form-field>


      <mat-form-field>
        <mat-label>Amount Offered by Manager</mat-label>
        <input matInput formControlName="double_2" readonly="{{formReadOnly}}"><span
      matPrefix>$&nbsp;&nbsp;&nbsp;</span>
      @for (validation of validationMessages.description; track validation) {
        <mat-error>
          @if (form1.get('double_2').hasError(validation.type) && (form1.get('double_2').dirty || form1.get('double_2').touched)) {
            <mat-error class="error-message"
              >
              {{validation.message}}
            </mat-error>
          }
        </mat-error>
      }
      <mat-hint>May be $0 if no request</mat-hint>
    </mat-form-field>


    <mat-form-field>
      <mat-label>Amount Agreed by Guest and Manager</mat-label>
      <input matInput formControlName="double_3" readonly="{{formReadOnly}}"><span
    matPrefix>$&nbsp;&nbsp;&nbsp;</span>
    @for (validation of validationMessages.description; track validation) {
      <mat-error>
        @if (form1.get('double_3').hasError(validation.type) && (form1.get('double_3').dirty || form1.get('double_3').touched)) {
          <mat-error class="error-message"
            >
            {{validation.message}}
          </mat-error>
        }
      </mat-error>
    }
    <mat-hint>May be $0 if no request</mat-hint>
  </mat-form-field>
  <app-task-reservation-select [taskApi]="taskApi"> </app-task-reservation-select>
</div>
</div>
</form>
</div>